import React, { useState } from 'react';

const secciones = [
  {
    id: 'contabilidad',
    icono: '📒',
    titulo: 'Plan de Cuentas y Asientos',
    resumen: 'Como registrar operaciones contables',
    color: '#1e3a5f',
    contenido: [
      {
        subtitulo: 'Que es el Plan de Cuentas?',
        texto: 'Es el listado de todas las cuentas que usa la empresa para registrar su dinero, deudas, ganancias y gastos. Piensalo como los "cajones" donde va cada tipo de dinero. Ejemplos: Efectivo, Cuentas por Cobrar, Gastos de Alquiler.',
      },
      {
        subtitulo: 'Que es un Asiento Contable?',
        texto: 'Es el registro de una operacion economica. Cada asiento tiene al menos una linea de DEBITO y una de CREDITO, y el total de ambas debe ser igual (cuadrar). Ejemplo: cuando pagas un gasto, debitas "Gastos" y creditas "Efectivo".',
      },
      {
        subtitulo: 'Pasos para crear un asiento manual',
        pasos: [
          'Ir a Contabilidad → pestaña Asientos',
          'Clic en "Nuevo Asiento"',
          'Escribir una descripcion (ej: Pago de alquiler enero)',
          'Agregar lineas: seleccionar la cuenta, elegir si es Debito o Credito, y escribir el monto',
          'Verificar que el total Debito = total Credito (el sistema te avisa si no cuadra)',
          'Clic en "Guardar" — queda en borrador',
          'Cuando estes seguro, clic en "Publicar" para que afecte los reportes',
        ],
      },
      {
        subtitulo: 'Regla de oro',
        texto: 'Debito = Credito siempre. Si no cuadran, el sistema no te deja publicar.',
        alerta: true,
      },
    ],
  },
  {
    id: 'nomina',
    icono: '💰',
    titulo: 'Nomina Universal',
    resumen: 'Como procesar el pago de empleados',
    color: '#0f766e',
    contenido: [
      {
        subtitulo: 'Que hace este modulo?',
        texto: 'Calcula automaticamente cuanto cobran los empleados, cuanto se le descuenta de TSS (Seguro y AFP) y cuanto de ISR (impuesto sobre el salario). Al procesar, genera el asiento contable automaticamente.',
      },
      {
        subtitulo: 'TSS — Que es y cuanto es?',
        texto: 'La TSS (Tesoreria de la Seguridad Social) tiene dos partes: lo que descuenta al empleado (5.91% de su salario: 3.04% SFS + 2.87% AFP) y lo que paga la empresa por el empleado (15.29%: 7.09% SFS + 7.10% AFP + 1.10% SRL).',
      },
      {
        subtitulo: 'ISR — Que es y cuanto es?',
        texto: 'El ISR (Impuesto Sobre la Renta) se retiene al empleado segun su salario mensual: hasta RD$34,685 no paga nada; de ahi a RD$52,027 paga 15%; hasta RD$72,260 paga 20%; mas de eso paga 25%.',
      },
      {
        subtitulo: 'Pasos para procesar una nomina',
        pasos: [
          'Ir a Nomina Universal → clic en "Procesar Nueva Nomina"',
          'Seleccionar el rango de fechas del periodo (ej: 01/03/2026 al 31/03/2026)',
          'Clic en "Calcular Preview" — el sistema muestra cuanto cobra cada empleado',
          'Puedes ajustar dias trabajados o bonificaciones por empleado',
          'Clic en "Procesar Nomina" para guardar',
          'El asiento contable se genera automaticamente',
          'Cuando se haga el pago real, clic en "Marcar como Pagada"',
        ],
      },
      {
        subtitulo: 'Asiento que genera automaticamente',
        texto: 'DR Gasto Salarios + DR TSS Patronal | CR Salarios x Pagar + CR TSS x Pagar + CR ISR Retenido. Todo cuadrado automaticamente.',
      },
    ],
  },
  {
    id: 'activos',
    icono: '🏗️',
    titulo: 'Activos Fijos y Depreciacion',
    resumen: 'Como registrar equipos, vehiculos y edificios',
    color: '#b45309',
    contenido: [
      {
        subtitulo: 'Que es un Activo Fijo?',
        texto: 'Es un bien que la empresa compra para usar por varios anos, no para vender. Ejemplos: computadoras, vehiculos, muebles, edificios. Se registra por su costo completo al comprarlo.',
      },
      {
        subtitulo: 'Que es la Depreciacion?',
        texto: 'Como los activos se van "gastando" con el tiempo, cada mes se registra una parte de su costo como gasto. Esto se llama depreciacion. Al final de su vida util, el activo vale solo su "valor residual" (lo que se podria vender).',
      },
      {
        subtitulo: 'Metodos de depreciacion disponibles',
        texto: 'Linea Recta: se divide el costo entre los meses de vida util — mismo monto cada mes. Doble Saldo Decreciente (Acelerada): se deprecia mas al principio y menos al final, util para equipos tecnologicos.',
      },
      {
        subtitulo: 'Pasos para registrar un activo',
        pasos: [
          'Ir a Activos Fijos → clic en "Nuevo Activo"',
          'Llenar: Nombre, Categoria, Fecha de Compra, Costo de Adquisicion',
          'Indicar Valor Residual (cuanto valdra al final) y Vida Util en meses',
          'Elegir el Metodo de Depreciacion',
          'Asignar las cuentas contables (Cuenta Activo, Dep. Acumulada, Gasto Dep.)',
          'Guardar — el sistema muestra la cuota mensual estimada',
        ],
      },
      {
        subtitulo: 'Como aplicar la depreciacion mensual',
        pasos: [
          'Ir a la pestana "Depreciacion Mensual"',
          'Verificar que el periodo sea el correcto (YYYY-MM)',
          'Clic en "Calcular Preview" — ver cuanto se depreciara cada activo',
          'Clic en "Aplicar Depreciacion" para registrar y generar el asiento automatico',
          'Solo se puede aplicar una vez por periodo — el sistema lo controla',
        ],
      },
      {
        subtitulo: 'Asiento que genera automaticamente',
        texto: 'DR Gastos Depreciaciones (6.5) | CR Depreciacion Acumulada (1.2.2). Se genera en la fecha en que se aplica.',
        alerta: false,
      },
    ],
  },
  {
    id: 'dgii',
    icono: '🏛️',
    titulo: 'Reportes DGII',
    resumen: 'Formatos 606, 607, 608, IR-17 e IR-2',
    color: '#7c3aed',
    contenido: [
      {
        subtitulo: 'Que son estos reportes?',
        texto: 'Son declaraciones obligatorias que se envian a la DGII (Direccion General de Impuestos Internos) con informacion sobre las compras, ventas, y retenciones de la empresa.',
      },
      {
        subtitulo: '606 — Compras y Gastos',
        texto: 'Detalla todas las compras que hizo la empresa en el mes: a quien le compro, el NCF, el ITBIS pagado. Se genera automaticamente desde las Ordenes de Compra.',
      },
      {
        subtitulo: '607 — Ventas con NCF',
        texto: 'Detalla todas las ventas que hizo la empresa: a quien le vendio, el NCF emitido, el ITBIS cobrado. Se genera desde las Facturas emitidas.',
      },
      {
        subtitulo: '608 — Comprobantes Anulados',
        texto: 'Lista los NCF que fueron anulados durante el mes, ya sea de ventas o compras.',
      },
      {
        subtitulo: 'IR-17 — Retenciones Mensuales',
        texto: 'Declara cuanto ISR se retuvo a los empleados (asalariados) y a los proveedores durante el mes. Se alimenta automaticamente de la Nomina Universal.',
      },
      {
        subtitulo: 'IR-2 — ISR Anual Empresarial',
        texto: 'Es la declaracion anual de impuesto sobre la renta de la empresa. Calcula automaticamente ingresos, gastos, renta neta y aplica el 27% de ISR empresarial.',
      },
      {
        subtitulo: 'Como exportar para enviar a la DGII',
        pasos: [
          'Ir a Reportes DGII',
          'Seleccionar el mes y ano del reporte',
          'Elegir la pestana del formato (606, 607, 608, IR-17 o IR-2)',
          'Revisar los datos en pantalla',
          'Clic en "Exportar TXT" — se descarga el archivo en formato DGII',
          'Subir ese archivo al portal de la DGII (Oficina Virtual)',
        ],
      },
    ],
  },
  {
    id: 'notas',
    icono: '📝',
    titulo: 'Notas de Credito y Debito',
    resumen: 'Como corregir o ajustar facturas emitidas',
    color: '#059669',
    contenido: [
      {
        subtitulo: 'Cuando se usa una Nota de Credito?',
        texto: 'Cuando se necesita reducir el valor de una factura ya emitida. Ejemplos: devolucion de mercancia, descuento posterior, error en el precio. La nota de credito "cancela" parte o todo de la factura original.',
      },
      {
        subtitulo: 'Cuando se usa una Nota de Debito?',
        texto: 'Cuando se necesita aumentar el valor de una factura ya emitida. Ejemplo: se cobro menos de lo que debia, o hay un cargo adicional.',
      },
      {
        subtitulo: 'Pasos para crear una Nota de Credito',
        pasos: [
          'Ir a Notas de Credito/Debito → clic en "Nueva Nota"',
          'Elegir tipo: Credito o Debito',
          'Buscar y seleccionar la factura original que se va a ajustar',
          'Escribir el motivo (ej: Devolucion por producto defectuoso)',
          'Indicar el monto del ajuste',
          'Guardar y luego "Emitir" para que quede oficializada con NCF',
        ],
      },
      {
        subtitulo: 'Importante',
        texto: 'Una nota emitida no se puede modificar. Si hay un error, se anula y se crea una nueva. La anulacion queda registrada en el 608.',
        alerta: true,
      },
    ],
  },
  {
    id: 'cuentaspagar',
    icono: '💳',
    titulo: 'Cuentas por Pagar',
    resumen: 'Control de lo que la empresa le debe a proveedores',
    color: '#dc2626',
    contenido: [
      {
        subtitulo: 'Que es Cuentas por Pagar?',
        texto: 'Es el modulo que controla las deudas de la empresa con sus proveedores. Cuando se recibe una factura de un proveedor pero aun no se paga, queda como cuenta por pagar.',
      },
      {
        subtitulo: 'Aging — Que significa?',
        texto: 'El "aging" muestra cuanto tiempo tienen las deudas sin pagar: al dia, 1-30 dias, 31-60 dias, 61-90 dias, mas de 90 dias. Permite saber que facturas estan proximas a vencerse.',
      },
      {
        subtitulo: 'Como registrar un pago a proveedor',
        pasos: [
          'Ir a Cuentas por Pagar',
          'Buscar la cuenta del proveedor',
          'Clic en "Registrar Pago"',
          'Indicar monto, fecha y metodo de pago (transferencia, cheque, etc.)',
          'Confirmar — la deuda se reduce automaticamente',
        ],
      },
      {
        subtitulo: 'Como se crean las cuentas por pagar?',
        texto: 'Se crean automaticamente cuando se recibe una Orden de Compra en estado "recibida". No es necesario crearlas manualmente.',
      },
    ],
  },
  {
    id: 'bancos',
    icono: '🏦',
    titulo: 'Bancos y Tesoreria',
    resumen: 'Control de cuentas bancarias y movimientos',
    color: '#0891b2',
    contenido: [
      {
        subtitulo: 'Que puedo hacer aqui?',
        texto: 'Registrar las cuentas bancarias de la empresa, ver el saldo de cada una, y registrar depositos, retiros y transferencias entre cuentas.',
      },
      {
        subtitulo: 'Como registrar un movimiento bancario',
        pasos: [
          'Ir a Bancos & Tesoreria',
          'Seleccionar la cuenta bancaria',
          'Clic en "Nuevo Movimiento"',
          'Elegir tipo: Deposito o Retiro',
          'Escribir monto, fecha y descripcion',
          'Guardar',
        ],
      },
      {
        subtitulo: 'Conciliacion bancaria',
        texto: 'Es comparar los movimientos del sistema con el estado de cuenta del banco para asegurarse de que coincidan. Se recomienda hacerla mensualmente.',
      },
    ],
  },
];

export default function ManualUsuario() {
  const [seccionActiva, setSeccionActiva] = useState(secciones[0].id);
  const seccion = secciones.find(s => s.id === seccionActiva);

  const sty = {
    page:     { display: 'flex', minHeight: '100vh', fontFamily: 'sans-serif', background: '#f8fafc' },
    sidebar:  { width: 260, background: '#1e3a5f', padding: '24px 0', flexShrink: 0 },
    sTitle:   { color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: 1, padding: '0 20px 10px', textTransform: 'uppercase' },
    sItem:    (active, color) => ({
      display: 'flex', alignItems: 'center', gap: 10, padding: '12px 20px', cursor: 'pointer',
      background: active ? color + '33' : 'transparent',
      borderLeft: active ? `3px solid ${color}` : '3px solid transparent',
      color: active ? '#fff' : '#94a3b8', transition: 'all .15s',
    }),
    sIcon:    { fontSize: 18, width: 24, textAlign: 'center' },
    sLabel:   { fontSize: 13, fontWeight: 600 },
    sSub:     { fontSize: 11, color: '#64748b', marginTop: 2 },
    main:     { flex: 1, padding: 36, maxWidth: 820 },
    header:   { marginBottom: 28 },
    hBadge:   (color) => ({ display: 'inline-block', background: color, color: '#fff', borderRadius: 20, padding: '4px 14px', fontSize: 12, fontWeight: 700, marginBottom: 10 }),
    hTitle:   { fontSize: 26, fontWeight: 700, color: '#1e293b', margin: '0 0 6px' },
    hSub:     { color: '#64748b', fontSize: 15 },
    block:    { background: '#fff', borderRadius: 10, padding: '20px 24px', marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,.06)' },
    bTitle:   { fontSize: 15, fontWeight: 700, color: '#1e293b', marginBottom: 10 },
    bText:    { color: '#475569', fontSize: 14, lineHeight: 1.7 },
    alert:    { background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: 8, padding: '12px 16px', color: '#92400e', fontSize: 14, lineHeight: 1.6 },
    ol:       { paddingLeft: 20, margin: 0 },
    li:       { color: '#475569', fontSize: 14, lineHeight: 1.8 },
    tip:      { background: '#eff6ff', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#1d4ed8', marginTop: 10 },
    divider:  { border: 'none', borderTop: '1px solid #f1f5f9', margin: '20px 0' },
  };

  return (
    <div style={sty.page}>
      {/* Sidebar */}
      <div style={sty.sidebar}>
        <div style={sty.sTitle}>Manual de Usuario</div>
        {secciones.map(s => (
          <div key={s.id} style={sty.sItem(seccionActiva === s.id, s.color)} onClick={() => setSeccionActiva(s.id)}>
            <span style={sty.sIcon}>{s.icono}</span>
            <div>
              <div style={sty.sLabel}>{s.titulo}</div>
              <div style={sty.sSub}>{s.resumen}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Content */}
      <div style={sty.main}>
        <div style={sty.header}>
          <div style={sty.hBadge(seccion.color)}>{seccion.icono} Modulo</div>
          <h1 style={sty.hTitle}>{seccion.titulo}</h1>
          <p style={sty.hSub}>{seccion.resumen}</p>
        </div>

        {seccion.contenido.map((bloque, i) => (
          <div key={i} style={sty.block}>
            <div style={sty.bTitle}>{bloque.subtitulo}</div>
            {bloque.alerta ? (
              <div style={sty.alert}>⚠️ {bloque.texto}</div>
            ) : bloque.texto ? (
              <p style={{ ...sty.bText, margin: 0 }}>{bloque.texto}</p>
            ) : null}
            {bloque.pasos && (
              <>
                {bloque.texto && <hr style={sty.divider} />}
                <ol style={sty.ol}>
                  {bloque.pasos.map((paso, j) => (
                    <li key={j} style={sty.li}>{paso}</li>
                  ))}
                </ol>
              </>
            )}
          </div>
        ))}

        <div style={sty.tip}>
          💡 <b>Consejo:</b> Si tienes dudas sobre alguna operacion, primero usa el modo "borrador" o "preview" antes de confirmar. Siempre puedes anular o corregir antes de publicar.
        </div>
      </div>
    </div>
  );
}
